/**************************************************
 * Nombre:       TarjetaIndicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {NEGRITA} from "../../Constantes";
import {CountUp} from 'use-count-up'
import {useInView} from "react-intersection-observer";

const TarjetaIndicador = ({item}) => {
    const [ref, inView] = useInView();

    return (
        <Grid
            ref={ref}
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <img src={item.img} width={42} height={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontFamily: NEGRITA, fontSize: 40, textAlign: 'center'}}>
                    <span>{'+ '}</span>
                    <CountUp  isCounting={inView} end={item.numero}
                             duration={3.2} start={0}/>
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{fontSize: 20, fontWeight: 600, textAlign: 'center'}}>{item.nombre}</Typography>
            </Grid>


        </Grid>
    )

}
export default TarjetaIndicador